import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, Share2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { blogPosts } from '../data/blogPosts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: post.title,
        text: post.excerpt,
        url: window.location.href
      });
    }
  };

  return (
    <div className="page-wrapper">
      <SEO 
        title={post.title}
        description={post.metaDescription}
        keywords={post.metaKeywords}
        canonical={`https://dsotocleaning.com/blog/${post.slug}`}
        ogImage={post.featuredImage}
        ogType="article"
      />
      
      <Navigation />
      
      <article className="blog-post-container">
        <div className="blog-post-header">
          <div className="container">
            <Link to="/blog" className="back-link">
              <ArrowLeft size={20} />
              Back to Blog
            </Link>
            <div className="blog-post-meta">
              <span className="blog-category-large">{post.category}</span>
              <div className="blog-meta-items-large">
                <span className="blog-meta-item">
                  <Calendar size={18} />
                  {new Date(post.publishDate).toLocaleDateString('en-US', { 
                    year: 'numeric', month: 'long', day: 'numeric' 
                  })}
                </span>
                <span className="blog-meta-item">
                  <Clock size={18} />
                  {post.readTime}
                </span>
              </div>
            </div>
            <h1 className="blog-post-title">{post.title}</h1>
            <p className="blog-post-author">By {post.author}</p>
            <Button onClick={handleShare} variant="outline" className="share-button">
              <Share2 size={18} />
              Share Article
            </Button>
          </div>
        </div>

        <div className="blog-post-featured-image">
          <img src={post.featuredImage} alt={post.title} />
        </div>

        <div className="blog-post-content-wrapper">
          <div className="container-narrow">
            <div 
              className="blog-post-content prose"
              dangerouslySetInnerHTML={{ __html: post.content.replace(/\n/g, '<br />') }}
            />
          </div>
        </div>

        <div className="blog-post-footer">
          <div className="container-narrow">
            <div className="blog-post-cta">
              <h3>Ready to Optimize Your Fleet Operations?</h3>
              <p>Partner with D Soto Cleaning for professional fleet detailing at scale.</p>
              <Link to="/contact">
                <Button size="lg" className="cta-button">
                  Schedule Consultation
                </Button>
              </Link>
            </div>

            <div className="related-posts">
              <h3>Continue Reading</h3>
              <div className="related-posts-grid">
                {blogPosts.filter(p => p.id !== post.id).slice(0, 3).map((relatedPost) => (
                  <Link key={relatedPost.id} to={`/blog/${relatedPost.slug}`} className="related-post-card">
                    <img src={relatedPost.featuredImage} alt={relatedPost.title} />
                    <div className="related-post-content">
                      <span className="related-post-category">{relatedPost.category}</span>
                      <h4>{relatedPost.title}</h4>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogPost;
